module.exports = __webpack_public_path__ + "img/Background-A3-Posters-2366x901.55f90518.jpeg";